import CoreHttpError from '../repositories/errors/CoreHttpError';

export default {
	methods: {
		/**
		 * Shows an error modal with the given error message.
		 *
		 * @param {string} error The error message
		 * @param {string} title THe modal title
		 * @param {string} headerBgVariant The header background variant
		 * @param {string} headerTextVariant The header text variant
		 * @param {string} okVariant The OK button variant
		 * @returns {Promise}
		 */
		showErrorModal (
			error,
			title = 'Server Error',
			headerBgVariant = 'danger',
			headerTextVariant = 'light',
			okVariant = 'danger'
		) {
			let errorText;

			if (typeof error === 'object' && error instanceof Error) {
				if (error.isHandled) {
					return;
				}

				if (error instanceof CoreHttpError) {
					errorText = error.getErrorString();
				}

				errorText = errorText ?? error.toString();
				console.error('Error', errorText, error);
			}
			else if (typeof error === 'object') {
				// if error is an object, we will need to find the first cause of error
				errorText = '';

				for (const key in error) {
					if (!error.hasOwnProperty(key)) {
						continue;
					}

					let errorString = error[key][0];

					if (errorText !== '') {
						errorString = '\n' + errorString;
					}

					errorText = errorText + errorString;
				}
			}
			else {
				errorText = error;
			}

			return this.$bvModal.msgBoxOk(errorText, {
				title,
				headerBgVariant,
				headerTextVariant,
				okVariant
			});
		}
	}
};
